export default __webpack_public_path__ + "static/media/gallery_07.9f886e85.jpg";